import { selectCurrentPage } from './selectCurrentPage';
import { IApplicationState } from '../../types/redux';

export const selectHasPrevPage = (state: IApplicationState) => {
  return selectCurrentPage(state) > 1;
};
